export default __webpack_public_path__ + "tmp_src/components/Search/SearchForm.css.liquid";